'use strict';

angular.module('bringgApp').factory('SelectReasonIconService', function ($uibModal, $q) {
	var SelectReasonIconService = {};

	SelectReasonIconService.open = function (currentSelection) {
		var deferred = $q.defer();
		var modalInstance = $uibModal.open({
			backdrop: 'static',
			keyboard: true,
			controller: 'SelectReasonIconController',
			templateUrl: 'scripts/features/dialogs/select_reason_icon/select-reason-icon.html',
			resolve: {
				currentSelection: function () {
					return currentSelection;
				}
			}
		});

		modalInstance.result.then(
			function (result) {
				deferred.resolve(result);
			},
			function (reason) {
				deferred.reject();
			}
		);

		return deferred.promise;
	};

	return SelectReasonIconService;
});
